/* eslint-disable */
import React, { FC, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import withBrands from '../hoc/withBrands';
import withLocalization from '../hoc/withLocalization';
import { RootState } from '../../redux/rootReducer';
import './ParticipationDetails.scss';
import galleryModalCloseLogo from '../../features/siteTheme/Brands/tmvcs/logo/galleryModalCloseLogo.svg';
import intlModalCloseLogo from '../../features/siteTheme/Brands/tmvcs/logo/intlModalCloseLogo.svg';
import ParseHtml from '../common/ParseHtml';
interface ImgModalProps {
  localize?: any;
  image?: string;
  closeModal: () => void;
}

const ParticipationDetails: FC<any> = (props: ImgModalProps): ReactElement => {
  const { localize, closeModal } = props;
  const handleKeyDown = () => {};
  const offerDetails: any = useSelector((state: RootState) => state.offerDetails.pinOptOfferDetails);
  const pinOfferData: any = (offerDetails?.offers && offerDetails?.offers[0]) || '';
  const detailsPinOfferContent = pinOfferData?.dopCodeDetails || '';
  const noDopContent = localize('preview-sales-engine.static-content.copy.pbeo.dop-not-available') || '<p><strong>Unable to Display Offer Details</strong></p>\n\n<p> Participation details for this offer are temporarily unavailable</p>';
  const mainContent = detailsPinOfferContent || noDopContent;

  return (
    <div className="modal-overlay-part">
      <div className="modal-part">
        <div className="modal-part-head-container">
          <div className="modal-part-close">
            <button
              className="dop-modal-close-btn"
              // src={intlModalCloseLogo}
              // type="image"
              onClick={closeModal}
              aria-label="close"
            >
              <img src={intlModalCloseLogo} alt="close" className="close-icon" />
            </button>
          </div>
        </div>
        <div className="modal-content-part">
          <ParseHtml htmlInput={mainContent}></ParseHtml>
        </div>
      </div>
    </div>
  );
};
export default React.memo(withLocalization(withBrands(ParticipationDetails)));
